export default "__VITE_ASSET__DixlHK9K__"